import React from 'react'
import injectSheet from 'react-jss'
import styles from './action-remove-work.styles'
import CheckIcon from 'react-icons/lib/fa/minus'

const ActionRemoveWork = ({ classes, id, name, timestamp }) => {
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        <CheckIcon />
      </span>{' '}
      <div>
        <strong className={classes.name}>{name}</strong>&nbsp;removed a piece of
        work {timestamp} ago
      </div>
    </div>
  )
}

export default injectSheet(styles)(ActionRemoveWork)
